let result = [];

for (let i = 0; i < 24; i++) {
    result.push({
        id: i,
        time: (i < 10 ? '0' + i : i) + ':00',
        in: parseInt(Math.random() * 100),
        out: parseInt(Math.random() * 100),
    })
}

export default result;


// WEBPACK FOOTER //
// ./src/configure/http/mock/response/index/loadCLTJData.js